import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { colors, css } from "../../../Styles";
import { NumberDisplayList, StationCard, LOCATIONLIST, NewButtonList } from "../..";
import { LocationListTypes } from "../../Animals/_Animals/locationContext";
import { currentContentTypes, currentInnerContentTypes, useModalContext } from "../../GlobalModals/_GlobalModals/globalModalContext";
import { NavigationFunction as RootNavigation, Pages } from "../../../Navigation/root";
import { NewProgressCicle } from "../../_Components";
import { ButtonTypes } from "../../../Definitions";
import { System } from "../../../Services";
import { LocationWithSectionAndSystem } from "../../../Services/Agrisys_GqlDataCaller/SectionsCalls/locationSlice";
import { Location } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall"
import { SET_ACTIVE_PEN } from "../../../Store/UI/modalRedirectSlice"
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import TenDaysGraphComponents from "../../Graphs/TenDaysComponentsViewer/tenDaysGraphComponents";
import { NonMilstoneProgressCircleWithDataProp } from "../../_Components/useDefaultProgressCircles";
import { useFeedByLocation } from "../../_Components/consumption";

interface sectionModal_Props {
  system: System;
  pen: Location | LocationWithSectionAndSystem,
  stations: number[]
}


export default function EsfSectionModal({ pen, stations, system }: sectionModal_Props) {
  const { t } = useTranslation()
  const navigator = useNavigate();
  const dispatchRoute = useDispatch();
  const { state, dispatch } = useModalContext();

  const { today } = useFeedByLocation(pen.location_id, 20000);
  // NumberDisplayList: Currently in this section TODO
  const FeedCorrections: JSX.Element = useMemo(() => {
    return (
      <NumberDisplayList
        height="64px"
        gridRows="1fr"
        units={[t("esfWalkThroughPages.esfWalkThrough.stations", { defaultValue: "stations" }), t("esfWalkThroughPages.esfWalkThrough.animals", { defaultValue: "animals" })]}
        values={[pen.stations.length, pen.animals.length]}
        header={t("esfWalkThroughPages.sections.currentlyInThisPen", { defaultValue: "currently in this pen" })}
      />
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])

  const StationClick = (stationId: number) => {
    dispatch({
      activeStation: stationId,
      currentContent: currentContentTypes.station,
      currentInnerContent: currentInnerContentTypes.stations
    })
  }

  const AnimalClick = (animalId: number) => {
    dispatchRoute(SET_ACTIVE_PEN({
      type: "esf",
      location: state.activeLocation ?? -1,
      group: state.activeLocation ?? -1,
      system: system.system_id
    }));

    RootNavigation({
      Navigator: navigator,
      navigation_page: Pages.animals,
      navigation_tab: Pages.animal,
      replace: true,
      navArgs: { selected: animalId },
      currentDomain: state.farm
    });
  }
  // #region | Feed View State Router
  const activeContent = (index: number) =>
    (state.currentInnerContent === currentInnerContentTypes.stations && index === 0) ||
    (state.currentInnerContent === currentInnerContentTypes.feeding && index === 1) ||
    (state.currentInnerContent === currentInnerContentTypes.animals && index === 2)

  const FeedviewStateRouter = () => {
    switch (state.currentInnerContent) {
      case currentInnerContentTypes.animals:
        return (
          <div style={{}}>
            <LOCATIONLIST
              listType={LocationListTypes.pens}
              headerPen={true}
              systemType={system.fk_system_types}
              pens={[pen]}
              connect={{ connection: state.connection, farm: state.farm, domain: state.domain }}
              onAnimalClick={(animalId: number) => AnimalClick(animalId)}
            />
          </div>
        );
      case currentInnerContentTypes.feeding:
        return (<div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
          {!pen.animals || pen.animals.length === 0 ?
            <p style={{ ...css.emptyPen, opacity: "0.5" }}>{t("noData", { defaultValue: "no data" })}</p>
            : <TenDaysGraphComponents data={pen.animals} />}
        </div>);
      case currentInnerContentTypes.stations:
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            {stations.map((station) =>
              <StationCard key={station} stationId={station} onClick={() => StationClick(station)} />
            )}
          </div>
        );
      default:
        return null;
    }
  }
  // #endregion

  return (<>
    <div style={{ ...css.modalTop, width: "655px" }}>
      <div style={{ display: 'flex' }}>
        <NonMilstoneProgressCircleWithDataProp circleId={1} total={today?.total ?? 0} progressed={today?.progressed ?? 0} />
        <NewProgressCicle key={`progressCircleMissing-${pen.location_id}`} animals={pen.animals} connect={{ connection: state.connection, domain: state.domain }} circleId={4} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "100%" }}>
        {FeedCorrections}
      </div>
    </div>
    <div style={{ ...css.seperatorLine, width: "735px" }} />
    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", gap: "20px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "0px 10px", borderTop: "1px solid " + colors.greyTertiary, borderBottom: "1px solid " + colors.greyTertiary, height: "40px", marginTop: "5px" }}>
        <NewButtonList
          contents={[
            t("esfWalkThroughPages.esfWalkThrough.stations", { defaultValue: "stations" }),
            t("esfWalkThroughPages.sections.stationFeeding", { defaultValue: "feeding" }),
            t("esfWalkThroughPages.esfWalkThrough.animals", { defaultValue: "animals" }),
          ]}
          onClick={(i) => {
            if (i === 0) { dispatch({ currentInnerContent: currentInnerContentTypes.stations }) }
            if (i === 1) { dispatch({ currentInnerContent: currentInnerContentTypes.feeding }) }
            if (i === 2) { dispatch({ currentInnerContent: currentInnerContentTypes.animals }) }
          }}
          buttonType={ButtonTypes.textButton}
          listOverrides={{
            listGap: "5px"
          }}
          overrides={(index) => ({
            baseStyles: {
              backgroundColor: activeContent(index) ? colors.greyDarkPrimary : colors.transparent,
              padding: "8px 10px",
              borderRadius: "10px",
            },
            hoverStyles: {
              opacity: activeContent(index) ? 1 : 0.5,
            },
            contentStyles: {
              color: activeContent(index) ? colors.greyLightTertiary : colors.greyDarkPrimary,
            }
          })}
        />
      </div>
      {FeedviewStateRouter()}
    </div>
  </>)
}
